import { makeStyles } from '@material-ui/core'
import { StyleSheet } from 'react-native'
export const ACSharedStyles = StyleSheet.create({
  wrapper: {
    width: '100%',
    height: '100%'
  },
  container: {
    backgroundColor: '#fff',
    paddingHorizontal: 24
  },
  tableContainer: {
    marginVertical: 24
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center'
  },
  buttonContent: {
    marginTop: 0
  },
  headingContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center'
  },
  headingText: {
    fontSize: 24,
    fontWeight: 'bold'
  }
})

export const makeACStyles = makeStyles({
  container: {
    border: `1px solid #D3DCE6`,
    borderWidth: 1,
    borderRadius: 8
  },
  hightLightCol: {
    backgroundColor: '#ed1b2e26'
  },
  root: {
    '& .MuiTableHead-root': {
      backgroundColor: '#F4F4F4'
    },
    '& .MuiTableCell-head': {
      borderLeft: '1px solid rgba(224, 224, 224, 1)',
      color: '#58647A',
      fontSize: 14,
      fontStyle: 'normal',
      fontWeight: 700
    },
    '& .MuiTableCell-body': {
      borderLeft: '1px solid rgba(224, 224, 224, 1)',
      color: '#1C1D1F',
      fontSize: 14,
      fontStyle: 'normal',
      fontWeight: 400
    }
  },
  hightLightCell: {
    backgroundColor: '#ed1b2e26'
  }
})
